(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode('.pbs-root{position:fixed;left:0;bottom:0;display:flex;flex-direction:column;align-items:center;justify-content:flex-start;width:100%;height:fit-content;max-height:100vh;z-index:2}.pbs-dialog-reset{background-color:transparent;color:inherit;border:none;outline:none;padding:0;margin:0}.pbs-backdrop{position:fixed;top:0;left:0;width:100%;height:100%;background-color:transparent;z-index:1;transition:background-color .2s ease-out}.pbs-backdrop.hidden{visibility:hidden}.pbs-backdrop.open{background-color:#454545b3}.pbs-backdrop.transparent{background-color:transparent}.pbs-container{--pbs-container-background-color: rgb(240, 240, 240);background-color:var(--pbs-container-background-color);position:relative;display:none;flex-direction:column;align-items:center;justify-content:flex-start;width:92%;height:fit-content;max-height:100vh;border-radius:10px 10px 0 0}.pbs-container.open{display:flex}.pbs-container .pbs-gap-filler{position:absolute;bottom:calc(-100vh + .5px);left:0;background-color:var(--pbs-container-background-color);content:"";width:100%;height:100vh}.pbs-handle{position:relative;display:flex;align-items:center;justify-content:center;width:100%;height:30px;cursor:pointer}.pbs-handle.hidden{display:none}.pbs-button-reset{background-color:transparent;-webkit-appearance:none;-moz-appearance:none;appearance:none;outline:none;border:none}button:focus.pbs-button-reset{outline:none}.pbs-handle-bar{background-color:#a8a8a8;position:relative;width:12%;height:7px;border-radius:12px}.pbs-handle-bar.hidden{display:none}.pbs-content-wrapper{position:relative;width:100%;height:fit-content;max-height:100%;overflow-y:scroll}.pbs-content-wrapper::-webkit-scrollbar{display:none}.example{-ms-overflow-style:none;scrollbar-width:none}')),document.head.appendChild(e)}}catch(n){console.error("vite-plugin-css-injected-by-js",n)}})();
var Lt = Object.defineProperty;
var At = (t, n, e) => n in t ? Lt(t, n, { enumerable: !0, configurable: !0, writable: !0, value: e }) : t[n] = e;
var j = (t, n, e) => At(t, typeof n != "symbol" ? n + "" : n, e);
function H(t) {
  return typeof t == "string";
}
function Bt(t, n) {
  return t.classList.contains(Z(n));
}
function $(t, n) {
  t.classList.add(Z(n));
}
function rt(t, n) {
  t.classList.remove(Z(n));
}
function U(t, n, e) {
  H(e) && (H(n) && rt(t, n), $(t, e));
}
function Z(t) {
  return H(t) ? t.trim().replace(/\./g, "") : "";
}
function M(t) {
  return t.map((n) => Z(n)).filter(Boolean).join(" ");
}
function Dt(t) {
  return t.map((n) => n == null ? void 0 : n.trim()).filter(Boolean).map((n) => `.${n}`).join(" ");
}
const lt = "open", ut = "hidden";
function et(t, n) {
  const e = n;
  if (Array.isArray(t)) {
    t.forEach((r) => {
      q(r, e), r.setAttribute("aria-modal", e ? "true" : "false");
    });
    return;
  }
  q(t, e), t.setAttribute("aria-modal", e ? "true" : "false");
}
function q(t, n) {
  n ? ($(t, lt), rt(t, ut)) : ($(t, ut), rt(t, lt));
}
function yt(t) {
  return t instanceof HTMLElement;
}
function Y(t) {
  return typeof t == "number" && !Number.isNaN(t);
}
function Yt(t) {
  yt(t) && t.focus();
}
function It(t) {
  if (!yt(t) || t.offsetParent === null || "disabled" in t && t.disabled)
    return !1;
  const e = t.getAttribute("tabindex"), r = Y(e) ? parseInt(e, 10) : -1, i = [
    "INPUT",
    "BUTTON",
    "SELECT",
    "TEXTAREA",
    "A",
    "AREA",
    "IFRAME"
  ].includes(t.tagName), a = t instanceof HTMLAnchorElement && t.href !== "" || t instanceof HTMLAreaElement && t.href !== "";
  return i || a || r > -1;
}
var T = /* @__PURE__ */ ((t) => (t.Backdrop = "pbs-backdrop", t.Root = "pbs-root", t.Container = "pbs-container", t.GapFiller = "pbs-gap-filler", t.Handle = "pbs-handle", t.HandleBar = "pbs-handle-bar", t.ContentWrapper = "pbs-content-wrapper", t))(T || {}), ot = /* @__PURE__ */ ((t) => (t.Button = "pbs-button-reset", t.Dialog = "pbs-dialog-reset", t))(ot || {}), K = /* @__PURE__ */ ((t) => (t.Hidden = "hidden", t))(K || {});
function x(t, n, e) {
  const r = document.createElement(t);
  return n.split(" ").forEach((i) => {
    $(r, i);
  }), H(e) && r.setAttribute("data-testid", e), r;
}
const sn = {
  CONTENTS_WRAPPER: Dt([
    T.Root,
    T.ContentWrapper
  ])
};
function dt(t, n, e, r) {
  switch (r) {
    case "content-height":
      return n >= t ? Et(t, n, e) : 0;
    case "middle":
      return -(t / 2 - n);
    case "top":
      return -(t - n) + e;
    default:
      return 0;
  }
}
function Ct(t, n) {
  const e = n < t, r = n > t;
  return {
    isUp: e,
    isDown: r,
    stayedSame: n === t
  };
}
function Tt(t, n) {
  return n < t ? -(t - n) : n - t;
}
function W(t, n) {
  return t > n ? t - n : n - t;
}
function xt(t, n) {
  const e = t < n, r = t > n;
  return {
    isUp: e,
    isDown: r,
    stayedSame: t === n
  };
}
function ft(t, n, e) {
  const r = t === "above";
  return e.filter((o) => {
    const i = o * n.viewportHeight;
    return r ? n.visibleHeight < i : n.visibleHeight > i;
  });
}
function Et(t, n, e) {
  return -(t - n) + e;
}
function gt(t) {
  return Number(t.replace("px", ""));
}
function J(t, ...n) {
  return Number(t.toFixed(...n));
}
function vt(t) {
  const n = /(?<type>\w+)\((?<values>[^)]+)\)/g, e = [];
  let r;
  for (; (r = n.exec(t)) !== null; ) {
    const o = r[1], i = r[2].split(",").map((a) => a.trim());
    e.push({ type: o, values: i });
  }
  return e;
}
function Nt(t) {
  const n = t.style.transform, e = vt(n);
  return { transform: n, transformValues: e };
}
function wt(t, n) {
  const e = t.find(
    (r) => r.type.startsWith(n)
  );
  return e || null;
}
const it = "translate";
function I(t) {
  const n = t.style.transform, e = vt(n), r = wt(
    e,
    it
  );
  return St(r ?? {
    type: it,
    values: []
  });
}
function Q(t, { x: n, y: e }) {
  const {
    transform: r,
    transformValues: o
  } = Nt(t), i = wt(
    o,
    it
  );
  if (i) {
    const a = St(i);
    t.style.transform = `translate(${n ?? a.x ?? 0}px,${e ?? a.y ?? 0}px)`;
    return;
  }
  if (r) {
    t.style.transform = `${r}, translate(${n ?? 0}px,${e ?? 0}px)`;
    return;
  }
  t.style.transform = `translate(${n ?? 0}px,${e ?? 0}px)`;
}
function St(t) {
  if (t.type !== "translate")
    throw new Error(
      `Could not get coordinates from ${t.type}, since is not translate.`
    );
  const n = t.values[0], e = t.values[1];
  return {
    x: gt(n) ?? 0,
    y: gt(e) ?? 0
  };
}
function at(t) {
  return t != null;
}
function ht(t, {
  min: n,
  max: e
}) {
  return at(e) && t >= e ? e : at(n) && t <= n ? n : t;
}
const Ft = (t, n, e) => {
  n instanceof HTMLElement && !Bt(n, T.Handle) && e.scrollTop >= 1 || (t.isDragging = !0);
}, Mt = (t, n, e, r) => (o) => {
  r.startY = t.getCoordinates(o).y, r.containerStartTranslate = I(n), e.onDragStart();
}, Pt = (t, n, e, r, o) => (i) => {
  Rt(
    i,
    t,
    e,
    r,
    o,
    n,
    e.marginTop
  );
};
function Rt(t, n, e, r, o, i, a) {
  if (!r.isDragging || !Y(r.startY))
    return;
  const u = n.getCoordinates(t).y, s = Tt(r.startY, u), b = window.innerHeight, l = i.clientHeight, d = l - (r.containerStartTranslate.y + s);
  if (d >= b)
    return;
  const y = Ct(r.startY, u);
  if (y.isUp && !e.expandable && d >= l || e.preventClosing && d <= l)
    return;
  o.start(() => {
    Q(i, {
      y: r.containerStartTranslate.y + s
    });
  }, 0);
  const E = b - a, c = l - r.containerStartTranslate.y;
  if (y.isUp) {
    const C = E - c, w = E - d, k = ht(
      1 - J(w / C, 2),
      {
        min: 0,
        max: 1
      }
    );
    e.onDragMove(y, k);
  } else if (y.isDown) {
    const C = ht(
      J(
        1 - d / c,
        2
      ),
      {
        min: 0,
        max: 1
      }
    );
    e.onDragMove(y, C);
  }
}
const Gt = (t, n, e, r, o, i, a) => (u) => {
  if (!r.isDragging || (r.isDragging = !1, !Y(r.startY)))
    return;
  e.onDragEnd();
  const s = r.startY, b = t.getCoordinates(u).y, l = I(n).y, d = Ct(s, b), y = window.innerHeight, E = n.clientHeight;
  if (d.isUp) {
    const c = [...e.snapPoints].sort(
      (k, B) => k - B
    ), C = E + -l;
    if (!e.expandable && C >= E)
      return;
    for (const k of c) {
      const B = k * window.innerHeight;
      if (C <= B) {
        const O = W(
          C,
          B
        );
        a.translateContainer({
          startY: l,
          endY: l - O,
          animationFrame: o,
          bottomSheetContainer: n
        });
        return;
      }
    }
    const w = Et(
      y,
      E,
      e.marginTop
    );
    a.translateContainer({
      startY: l,
      endY: w,
      animationFrame: o,
      bottomSheetContainer: n
    });
  } else if (d.isDown) {
    const c = [...e.snapPoints].sort(
      (C, w) => w - C
    );
    for (const C of c) {
      const w = C * window.innerHeight, k = E + -l;
      if (k >= w) {
        const B = W(
          k,
          w
        );
        a.translateContainer({
          startY: l,
          endY: l + B,
          animationFrame: o,
          bottomSheetContainer: n
        });
        return;
      }
    }
    if (e.preventClosing) {
      const C = E + -l;
      if (C >= E) {
        const w = W(C, E);
        a.translateContainer({
          startY: l,
          endY: l + w,
          animationFrame: o,
          bottomSheetContainer: n
        });
      }
      return;
    }
    i();
  }
};
var G = /* @__PURE__ */ ((t) => (t[t.All = -1] = "All", t[t.None = 0] = "None", t[t.Capture = 1] = "Capture", t[t.Target = 2] = "Target", t[t.Bubble = 3] = "Bubble", t))(G || {});
function mt(t) {
  switch (t) {
    case 0:
      return 0;
    case 1:
      return 1;
    case 2:
      return 2;
    case 3:
      return 3;
    default:
      return -1;
  }
}
const _t = {
  eventPhase: G.All
};
class V {
  constructor(n) {
    j(this, "currentTarget");
    this.currentTarget = n;
  }
  addEventListeners({
    onStart: n,
    onStartOptions: e = _t,
    onMove: r,
    onEnd: o
  }) {
    this.addTouchEventListeners({ onStart: n, onStartOptions: e, onMove: r, onEnd: o }), this.addMouseEventListeners({ onStart: n, onStartOptions: e, onMove: r, onEnd: o });
  }
  addTouchEventListeners({
    onStart: n,
    onStartOptions: e,
    onMove: r,
    onEnd: o
  }) {
    n && this.currentTarget.addEventListener(
      "touchstart",
      (i) => {
        if (e.eventPhase === G.All) {
          n(i);
          return;
        }
        mt(i.eventPhase) === e.eventPhase && n(i);
      },
      {
        passive: !0
      }
    ), r && this.currentTarget.addEventListener("touchmove", r), o && this.currentTarget.addEventListener("touchend", o);
  }
  addMouseEventListeners({
    onStart: n,
    onStartOptions: e,
    onMove: r,
    onEnd: o
  }) {
    n && this.currentTarget.addEventListener(
      "mousedown",
      (i) => {
        if (e.eventPhase === G.All) {
          n(i);
          return;
        }
        mt(i.eventPhase) === e.eventPhase && n(i);
      },
      {
        passive: !0
      }
    ), r && this.currentTarget.addEventListener("mousemove", r), o && this.currentTarget.addEventListener("mouseup", (i) => {
      o(i);
    });
  }
  removeEventListeners({
    onStart: n,
    onMove: e,
    onEnd: r
  }) {
    n && this.currentTarget.removeEventListener("touchstart", n), r && this.currentTarget.removeEventListener("touchend", r), e && this.currentTarget.removeEventListener("touchmove", e), n && this.currentTarget.removeEventListener("mousedown", n), e && this.currentTarget.removeEventListener("mousemove", e), r && this.currentTarget.removeEventListener("mouseup", r);
  }
  getCoordinates(n) {
    if (n.type === "touchstart" || n.type === "mousedown") {
      if ("touches" in n)
        return {
          x: n.touches[0].clientX,
          y: n.touches[0].clientY
        };
      if (n instanceof MouseEvent)
        return {
          x: n.clientX,
          y: n.clientY
        };
    }
    if (n.type === "touchend" || n.type === "mouseup" || n.type === "mousemove" || n.type === "touchmove") {
      if ("touches" in n)
        return {
          x: n.changedTouches[0].clientX,
          y: n.changedTouches[0].clientY
        };
      if (n instanceof MouseEvent)
        return {
          x: n.clientX,
          y: n.clientY
        };
    }
    return {
      x: 0,
      y: 0
    };
  }
}
function Ht(t) {
  const n = t;
  return `${n} ${n} 0px 0px`;
}
function jt(t, n) {
  const e = Ut(t);
  Vt(e), e.bottomSheetContainer.style.width = t.width;
  const r = document.createElement("div");
  r.innerHTML = t.content ?? "";
  const o = window.innerHeight;
  e.bottomSheetContainer.style.maxHeight = `${o}px`, e.bottomSheetContentWrapper.appendChild(r);
  const i = Wt({
    bottomSheetElements: e,
    bottomSheetProps: t,
    options: n
  });
  return t.rootStyle && Object.assign(e.bottomSheetRoot.style, t.rootStyle), t.backdropStyle && Object.assign(e.bottomSheetBackdrop.style, t.backdropStyle), t.containerGapFillerStyle && Object.assign(e.bottomSheetContainer.style, t.containerStyle), t.containerStyle && Object.assign(
    e.bottomSheetContainerGapFiller.style,
    t.containerGapFillerStyle
  ), t.handleStyle && Object.assign(e.bottomSheetHandleBar.style, t.handleStyle), t.contentWrapperStyle && Object.assign(
    e.bottomSheetContentWrapper.style,
    t.contentWrapperStyle
  ), { elements: e, eventHandlers: i };
}
function Ut(t) {
  const n = x(
    "dialog",
    M([
      T.Root,
      ot.Dialog,
      t.rootClass
    ]),
    T.Root
  );
  n.ariaLabel = t.ariaLabel;
  const e = x(
    "section",
    M([T.Container, t.containerClass]),
    T.Container
  );
  t.containerBorderRadius && (e.style.borderRadius = Ht(
    t.containerBorderRadius
  ));
  const r = x(
    "div",
    T.GapFiller,
    T.GapFiller
  );
  t.containerBackgroundColor && (e.style.backgroundColor = t.containerBackgroundColor, r.style.backgroundColor = t.containerBackgroundColor);
  const o = x(
    "button",
    M([
      T.Handle,
      ot.Button,
      t.shouldShowHandle ? null : K.Hidden,
      t.handleClass
    ]),
    T.Handle
  );
  o.setAttribute("type", "button"), o.ariaLabel = "bottom sheet close button";
  const i = x(
    "span",
    M([
      T.HandleBar,
      t.shouldShowHandle ? null : K.Hidden
    ]),
    T.HandleBar
  ), a = x(
    "article",
    M([
      T.ContentWrapper,
      t.contentWrapperClass
    ]),
    T.ContentWrapper
  ), u = x(
    "div",
    M([
      T.Backdrop,
      t.backdropClass,
      K.Hidden
    ]),
    T.Backdrop
  );
  return t.backdropColor && (u.style.backgroundColor = t.backdropColor), t.backDropTransition && (u.style.transition = t.backDropTransition), {
    bottomSheetRoot: n,
    bottomSheetBackdrop: u,
    bottomSheetContainer: e,
    bottomSheetHandle: o,
    bottomSheetHandleBar: i,
    bottomSheetContentWrapper: a,
    bottomSheetContainerGapFiller: r
  };
}
function Vt({
  bottomSheetRoot: t,
  bottomSheetContainer: n,
  bottomSheetHandle: e,
  bottomSheetHandleBar: r,
  bottomSheetContentWrapper: o,
  bottomSheetContainerGapFiller: i
}) {
  t.appendChild(n), e.appendChild(r), n.appendChild(e), n.appendChild(o), n.appendChild(i);
}
function Wt({
  bottomSheetElements: t,
  bottomSheetProps: n,
  options: e
}) {
  const {
    bottomSheetRoot: r,
    bottomSheetContainer: o,
    bottomSheetHandle: i,
    bottomSheetContainerGapFiller: a,
    bottomSheetContentWrapper: u,
    bottomSheetBackdrop: s
  } = t, { animationFrame: b } = e, l = new V(i), d = new V(
    u
  ), y = new V(
    a
  );
  let E = [];
  const c = new V(
    window
  ), C = Mt(
    c,
    o,
    n,
    e.draggingState
  ), w = Pt(
    c,
    o,
    n,
    e.draggingState,
    b
  ), k = Gt(
    c,
    o,
    n,
    e.draggingState,
    b,
    e.onClose,
    e.bottomSheetState
  );
  function B(S) {
    S.target instanceof Element && !r.contains(S.target) && e.onClose();
  }
  function O(S) {
    Ft(
      e.draggingState,
      S.target,
      t.bottomSheetContentWrapper
    );
  }
  function N(S) {
    const L = S ?? n;
    L.draggable && L.backgroundDraggable && (d.addEventListeners({
      onStart: O,
      onStartOptions: {
        eventPhase: G.Target
      }
    }), y.addEventListeners({
      onStart: O
    })), L.draggable && c.addEventListeners({
      onStart: C,
      onMove: w,
      onEnd: k
    }), L.draggable && window.document.addEventListener("keyup", (p) => {
      p.key === "Escape" && e.onClose();
    }), i.addEventListener("keyup", (p) => {
      if (p.key === "ArrowUp") {
        e.moveUp();
        return;
      }
      if (p.key === "ArrowDown") {
        e.moveDown();
        return;
      }
      if (p.shiftKey && p.key === "Tab") {
        const F = nt(
          t.bottomSheetContentWrapper
        );
        Yt(F);
      }
    });
  }
  function X(S) {
    const L = S ?? n;
    n.shouldCloseOnOutsideClick && !n.preventClosing ? s.addEventListener("click", B) : s.style.pointerEvents = "none", L.draggable && (l.addEventListeners({
      onStart: O
    }), E.forEach((p) => {
      p.removeEventListeners({
        onStart: O
      });
    }), E = n.dragTriggers.reduce((p, F) => {
      const g = r.querySelectorAll(F);
      if (!g.length)
        return p;
      const h = Array.from(g).map((f) => f instanceof HTMLElement ? new V(f) : null).filter((f) => !!f);
      return [...p, ...h];
    }, []), E.forEach((p) => {
      p.addEventListeners({
        onStart: O,
        onStartOptions: {
          eventPhase: G.Target
        }
      });
    }));
  }
  function tt() {
    s.removeEventListener("click", B);
  }
  function nt(S) {
    let L = [...Array.from(S.childNodes).reverse()];
    for (; L.length; ) {
      const p = L.shift();
      if (It(p))
        return p;
      p && (L = [
        ...L,
        ...Array.from(p.childNodes).reverse()
      ]);
    }
    return null;
  }
  function z() {
    l.removeEventListeners({
      onStart: O
    }), d.removeEventListeners({
      onStart: O
    }), y.removeEventListeners({
      onStart: O
    }), E.forEach((S) => {
      S.removeEventListeners({
        onStart: O
      });
    }), c.removeEventListeners({
      onStart: C,
      onMove: w,
      onEnd: k
    });
  }
  return {
    attachEventListeners: N,
    clearEventListeners: z,
    attacheOnOpenEventListeners: X,
    clearOnOpenEventListeners: tt
  };
}
class $t {
  constructor() {
    j(this, "animationId");
    j(this, "isInProgress");
    j(this, "startedAt");
    this.animationId = null, this.isInProgress = !1, this.startedAt = null;
  }
  /**
   *
   * @param renderFrame- Function to render screen using the animation progress percentage.
   * @param duration- Duration of the animation, in MS.
   */
  start(n, e, r = !1) {
    this.isInProgress = !0;
    const o = (i) => {
      this.startedAt || (this.startedAt = i);
      const a = i - this.startedAt, s = e === 0 ? 1 : J(a / e, 2), b = s >= 1 && !r;
      n(s), b ? this.stop() : this.animationId = requestAnimationFrame(o);
    };
    this.animationId = requestAnimationFrame(o);
  }
  stop() {
    this.isInProgress = !1, this.startedAt = null, Y(this.animationId) && cancelAnimationFrame(this.animationId);
  }
}
function Xt(t) {
  const {
    startY: n,
    endY: e,
    bottomSheetContainer: r,
    animationFrame: o,
    onEnd: i,
    animationTimingFunction: a,
    animationDuration: u
  } = t, s = Tt(n, e);
  o.stop();
  let b = !1;
  o.start((l) => {
    Q(r, {
      y: n + s * a(l)
    }), !b && l >= 1 && (i == null || i(), b = !0);
  }, u);
}
const st = (t, n) => (e) => {
  Xt({
    ...e,
    animationTimingFunction: t,
    animationDuration: n
  });
}, R = {
  TOP: "top",
  MIDDLE: "middle",
  CONTENT_HEIGHT: "content-height",
  CLOSED: "closed"
};
function zt(t) {
  return !(!Y(t) || t > 1 || t < 0);
}
function Kt(t, n) {
  const e = {
    set(r, o, i, a) {
      return n(o, i), Reflect.set(r, o, i, a);
    }
  };
  return new Proxy(t, e);
}
function qt(...t) {
  console.error(t);
}
const P = {
  EASE: "ease",
  EASE_IN: "ease-in",
  EASE_OUT: "ease-out",
  EASE_IN_OUT: "ease-in-out",
  SPRING: "spring"
};
function Jt(t) {
  for (const n of Object.values(P))
    if (n === t)
      return !0;
  return !1;
}
function Ot(t) {
  return !!(t instanceof Object && "p1x" in t && "p1y" in t && "p2x" in t && "p2y" in t && Y(t.p1x) && Y(t.p1y) && Y(t.p2x) && Y(t.p2y));
}
function _(t, n, e, r) {
  return function(s) {
    return u(i(s));
  };
  function i(s) {
    let b = 0, l = 1, d = s, y;
    if (s === 0 || s === 1)
      return s;
    for (; b < l; ) {
      if (y = a(d), Math.abs(y - s) < 1e-3)
        return d;
      s > y ? b = d : l = d, d = (l + b) / 2;
    }
    return d;
  }
  function a(s) {
    return 3 * t * s * Math.pow(1 - s, 2) + 3 * e * Math.pow(s, 2) * (1 - s) + Math.pow(s, 3);
  }
  function u(s) {
    return 3 * n * s * Math.pow(1 - s, 2) + 3 * r * Math.pow(s, 2) * (1 - s) + Math.pow(s, 3);
  }
}
const bt = _(0.25, 0.1, 0.25, 1), Qt = _(0.42, 0, 1, 1), kt = _(0.42, 0, 0.58, 1), Zt = _(0.4, 0.1, 0.6, 1), tn = _(0.45, 1.5, 0.55, 1);
function nn(t) {
  switch (t) {
    case P.EASE:
      return bt;
    case P.EASE_IN:
      return Qt;
    case P.EASE_OUT:
      return kt;
    case P.EASE_IN_OUT:
      return Zt;
    case P.SPRING:
      return tn;
    default:
      return bt;
  }
}
function pt(t) {
  return typeof t == "boolean";
}
const en = {
  ariaLabel: "Bottom sheet",
  content: "",
  defaultPosition: R.CONTENT_HEIGHT,
  marginTop: 20,
  snapPoints: [],
  width: "92%",
  dragTriggers: [],
  beforeOpen: () => {
  },
  afterOpen: () => {
  },
  beforeClose: () => {
  },
  afterClose: () => {
  },
  onDragStart: () => {
  },
  onDragMove: () => {
  },
  onDragEnd: () => {
  },
  expandable: !0,
  preventClosing: !1,
  draggable: !0,
  backgroundDraggable: !0,
  shouldCloseOnOutsideClick: !0,
  shouldShowBackdrop: !0,
  shouldShowHandle: !0,
  backDropTransition: null,
  backdropColor: null,
  containerBackgroundColor: null,
  containerBorderRadius: null,
  rootClass: null,
  containerClass: null,
  handleClass: null,
  contentWrapperClass: null,
  backdropClass: null,
  draggingAnimationTimings: "ease-in-out",
  draggingAnimationDuration: 180,
  rootStyle: {},
  containerStyle: {},
  handleStyle: {},
  contentWrapperStyle: {},
  backdropStyle: {},
  containerGapFillerStyle: {}
};
function rn(t) {
  const n = {
    ...en
  }, e = Object.entries(t).reduce(
    (o, i) => {
      const [a, u] = i;
      return at(u) && (o[a] = u), o;
    },
    {}
  );
  return {
    ...n,
    ...e
  };
}
function ct(t) {
  if (Ot(t)) {
    const { p1x: n, p1y: e, p2x: r, p2y: o } = t;
    return _(n, e, r, o);
  }
  return Jt(t) ? nn(t) : kt;
}
function on(t, n, e, r) {
  function o(i, a) {
    switch (i) {
      case "content":
        H(a) && (t.bottomSheetContentWrapper.innerHTML = a);
        break;
      case "width":
        H(a) && (t.bottomSheetContainer.style.width = a);
        break;
      case "shouldShowHandle":
        pt(a) || q(t.bottomSheetHandle, !1);
        break;
      case "shouldShowBackdrop":
        pt(a) || q(t.bottomSheetBackdrop, !1);
        break;
      case "containerBorderRadius":
        H(a) && (t.bottomSheetContainer.style.borderRadius = Ht(a));
        break;
      case "containerBackgroundColor":
        H(a) && (t.bottomSheetContainer.style.backgroundColor = a, t.bottomSheetContainerGapFiller.style.backgroundColor = a);
        break;
      case "backdropColor":
        H(a) && (t.bottomSheetBackdrop.style.backgroundColor = a);
        break;
      case "backDropTransition":
        H(a) && (t.bottomSheetBackdrop.style.transition = a);
        break;
      case "rootClass":
        if (!H(a))
          return;
        U(
          t.bottomSheetRoot,
          e.rootClass,
          a
        );
        break;
      case "containerClass":
        if (!H(a))
          return;
        U(
          t.bottomSheetContainer,
          e.containerClass,
          a
        );
        break;
      case "handleClass":
        if (!H(a))
          return;
        U(
          t.bottomSheetHandle,
          e.handleClass,
          a
        );
        break;
      case "contentWrapperClass":
        if (!H(a))
          return;
        U(
          t.bottomSheetContentWrapper,
          e.contentWrapperClass,
          a
        );
        break;
      case "backdropClass":
        if (!H(a))
          return;
        U(
          t.bottomSheetBackdrop,
          e.backdropClass,
          a
        );
        break;
      case "expandable":
        r.clearEventListeners(), r.attachEventListeners(e);
        break;
      case "preventClosing":
        r.clearEventListeners(), r.attachEventListeners(e);
        break;
      case "draggable":
        r.clearEventListeners(), r.attachEventListeners(e);
        break;
      case "dragTriggers":
        r.clearEventListeners(), r.attachEventListeners(e);
        break;
      case "draggingAnimationTimings":
        if (Ot(a)) {
          const u = ct(a), s = st(
            u,
            e.draggingAnimationDuration
          );
          n.translateContainer = s;
        }
        break;
      case "draggingAnimationDuration":
        if (Y(a)) {
          const u = ct(
            e.draggingAnimationTimings
          ), s = st(
            u,
            a
          );
          n.translateContainer = s;
        }
        break;
      case "rootStyle":
        e.rootStyle && Object.assign(
          t.bottomSheetRoot.style,
          e.rootStyle
        );
        break;
      case "backdropStyle":
        e.backdropStyle && Object.assign(
          t.bottomSheetBackdrop.style,
          e.backdropStyle
        );
        break;
      case "containerStyle":
        e.containerStyle && Object.assign(
          t.bottomSheetContainer.style,
          e.containerStyle
        );
        break;
      case "containerGapFillerStyle":
        e.containerGapFillerStyle && Object.assign(
          t.bottomSheetContainerGapFiller.style,
          e.containerGapFillerStyle
        );
        break;
      case "handleStyle":
        e.handleStyle && Object.assign(
          t.bottomSheetHandleBar.style,
          e.handleStyle
        );
        break;
      case "contentWrapperStyle":
        e.contentWrapperStyle && Object.assign(
          t.bottomSheetContentWrapper.style,
          e.contentWrapperStyle
        );
        break;
    }
  }
  return o;
}
function cn(t) {
  const n = rn(t), e = ct(
    t.draggingAnimationTimings
  ), o = {
    isMounted: !1,
    translateContainer: st(
      e,
      n.draggingAnimationDuration
    )
  }, i = {
    startY: null,
    containerStartTranslate: {
      x: 0,
      y: 0
    },
    isDragging: !1,
    originalDocumentOverflowY: null,
    originalDocumentOverscrollBehavior: null
  };
  function a() {
    i.originalDocumentOverflowY && i.originalDocumentOverflowY !== "hidden" && (document.body.style.overflowY = i.originalDocumentOverflowY), i.originalDocumentOverscrollBehavior && (document.body.style.position = i.originalDocumentOverscrollBehavior);
  }
  const u = new $t(), s = {
    animationFrame: u,
    onClose: B,
    bottomSheetState: o,
    draggingState: i,
    snapTo: F,
    moveUp: L,
    moveDown: p
  }, { elements: b, eventHandlers: l } = jt(
    n,
    s
  ), d = Kt(
    n,
    on(
      b,
      o,
      n,
      l
    )
  ), { bottomSheetBackdrop: y, bottomSheetRoot: E, bottomSheetContainer: c } = b, C = (g) => {
    const h = g ?? window.document.body;
    h.appendChild(E), h.appendChild(y);
    const f = window.innerHeight;
    Q(c, {
      y: f
    }), l.attachEventListeners(), o.isMounted = !0;
  }, w = () => {
    l.clearEventListeners(), Object.values(b).forEach((g) => {
      g.remove();
    }), a(), o.isMounted = !1;
  }, k = () => {
    var D;
    if (O() || qt(
      'Bottom Sheet is not mounted yet. call the "mount" method first.'
    ), (D = t.beforeOpen) == null || D.call(t), N())
      return;
    et(y, !0), d.shouldShowBackdrop || $(y, "transparent"), et([c], !0), Q(c, {
      y: c.clientHeight
    });
    const h = window.innerHeight, f = dt(
      h,
      c.clientHeight,
      d.marginTop,
      d.defaultPosition
    ), m = I(c).y;
    o.translateContainer({
      startY: m,
      endY: f,
      animationFrame: u,
      bottomSheetContainer: c,
      onEnd: t.afterOpen
    });
    const v = document.body.style.overflowY;
    i.originalDocumentOverflowY = v || "initial";
    const A = document.body.style.overscrollBehavior;
    i.originalDocumentOverscrollBehavior = A || "initial", document.body.style.overflow = "hidden", document.body.style.overscrollBehavior = "contain", b.bottomSheetHandle.focus(), l.attacheOnOpenEventListeners();
  };
  function B() {
    var f;
    if (X())
      return;
    (f = t.beforeClose) == null || f.call(t);
    const g = I(c).y, h = c.clientHeight;
    o.translateContainer({
      startY: g,
      endY: h,
      animationFrame: u,
      bottomSheetContainer: c,
      onEnd: () => {
        var m;
        (m = t.afterClose) == null || m.call(t), et([y, c], !1), l.clearOnOpenEventListeners();
      }
    }), a();
  }
  function O() {
    return o.isMounted;
  }
  function N() {
    const g = I(c).y, h = window.innerHeight, f = c.clientHeight >= h ? h : c.clientHeight;
    return g <= f;
  }
  function X() {
    return !N();
  }
  function tt() {
    const g = I(c).y, h = c.clientHeight, f = window.innerHeight;
    if (g <= 5 && g >= -5)
      return R.CONTENT_HEIGHT;
    const m = h - g;
    if (m === f / 2)
      return R.MIDDLE;
    const v = f - d.marginTop, A = 10;
    return m <= v + A && m >= v - A ? R.TOP : R.CLOSED;
  }
  function nt() {
    return c.clientHeight;
  }
  function z(g) {
    if (!N())
      return;
    const h = I(c).y, m = c.clientHeight - h, v = window.innerHeight - g, A = xt(m, v), D = W(m, v);
    o.translateContainer({
      startY: h,
      endY: h + (A.isUp ? -D : D),
      animationFrame: u,
      bottomSheetContainer: c
    });
  }
  function S(g, {
    viewportHeight: h,
    visibleHeight: f
  }) {
    let m = null;
    for (const v of g) {
      const A = v * h, D = W(
        f,
        A
      );
      (m === null || D < m) && (m = D);
    }
    return {
      minOffset: m
    };
  }
  function L() {
    const g = [...d.snapPoints].reverse(), h = I(c).y, f = c.clientHeight, m = f - h;
    if (!d.expandable && m >= f)
      return;
    const v = window.innerHeight, A = ft(
      "above",
      { visibleHeight: m, viewportHeight: v },
      g
    ), { minOffset: D } = S(A, {
      visibleHeight: m,
      viewportHeight: v
    });
    if (D === null && m < v - d.marginTop) {
      o.translateContainer({
        startY: h,
        endY: dt(
          v,
          f,
          d.marginTop,
          "top"
        ),
        animationFrame: u,
        bottomSheetContainer: c
      });
      return;
    }
    Y(D) && o.translateContainer({
      startY: h,
      endY: h - D,
      animationFrame: u,
      bottomSheetContainer: c
    });
  }
  function p() {
    const g = I(c).y, f = c.clientHeight - g;
    if (f < 1)
      return;
    const m = window.innerHeight, v = ft(
      "below",
      { visibleHeight: f, viewportHeight: m },
      d.snapPoints
    ), { minOffset: A } = S(v, {
      visibleHeight: f,
      viewportHeight: m
    });
    Y(A) && o.translateContainer({
      startY: g,
      endY: g + A,
      animationFrame: u,
      bottomSheetContainer: c
    });
  }
  function F(g) {
    const h = window.innerHeight;
    if (!zt(g))
      return;
    const f = J(h * g, 2);
    z(f);
  }
  return {
    props: d,
    elements: b,
    mount: C,
    unmount: w,
    open: k,
    close: B,
    getIsMounted: O,
    getIsOpen: N,
    getIsClosed: X,
    getPosition: tt,
    getHeight: nt,
    moveTo: z,
    snapTo: F
  };
}
function ln() {
  return {
    elements: {
      bottomSheetRoot: void 0,
      bottomSheetBackdrop: void 0,
      bottomSheetContainer: void 0,
      bottomSheetHandle: void 0,
      bottomSheetHandleBar: void 0,
      bottomSheetContentWrapper: void 0,
      bottomSheetContainerGapFiller: void 0
    },
    mount: () => {
    },
    unmount: () => {
    },
    open: () => {
    },
    close: () => {
    },
    getIsMounted: () => !1,
    getHeight: () => 0,
    getIsOpen: () => !1,
    getIsClosed: () => !0,
    getPosition: () => R.CLOSED,
    moveTo: () => {
    },
    snapTo: () => {
    },
    props: {
      content: ""
    }
  };
}
export {
  en as BOTTOM_SHEET_DEFAULT_PROPS,
  R as BOTTOM_SHEET_POSITION,
  sn as BOTTOM_SHEET_SELECTORS,
  P as COMMON_ANIMATION_KEYS,
  T as ClassNames,
  G as EventPhase,
  ot as ResetClassNames,
  K as UtilClassNames,
  cn as createBottomSheet,
  ln as createPlaceholderBottomSheet,
  mt as eventPhaseToEnum,
  Ot as isAnimationTimingPoints,
  Jt as isCommonAnimationTimingsKey
};
